import permissions from "../../data/permissions"
export default [
    {
        name: "AdjustmentsList",
        path: "adjustments",
        component: () => import('../../views/warehouse/StockAdjustmentListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.stock_adjustment.index}
        

    },
    {
        name: "AdjustmentCreate",
        path: "adjustment-create",
        component: () => import('../../views/warehouse/StockAdjustmentCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.stock_adjustment.create }

    },
    {
        name: "AdjustmentDisplay",
        path: "adjustment/:id",
        component: () => import('../../views/warehouse/StockAdjustmentDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.stock_adjustment.read }

    },
    {
        name: "AdjustmentEdit",
        path: "adjustment/:id/edit",
        component: () => import('../../views/warehouse/StockAdjustmentEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.stock_adjustment.update }

    }
]